import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M19.467 2.4c1.178 0 2.133.942 2.133 2.104v3.592c0 1.162-.955 2.104-2.133 2.104h-3.2c-1.178 0-2.133-.942-2.133-2.104V4.504c0-1.162.955-2.104 2.133-2.104zm-14.933 0C3.356 2.4 2.4 3.342 2.4 4.504v3.592c0 1.162.956 2.104 2.134 2.104h3.2c1.178 0 2.133-.942 2.133-2.104V4.504c0-1.162-.955-2.104-2.133-2.104zm14.933 11.4c1.178 0 2.133.942 2.133 2.104v3.592c0 1.162-.955 2.104-2.133 2.104h-3.2c-1.178 0-2.133-.942-2.133-2.104v-3.592c0-1.162.955-2.104 2.133-2.104zm-14.933 0c-1.178 0-2.134.942-2.134 2.104v3.592c0 1.162.956 2.104 2.134 2.104h3.2c1.178 0 2.133-.942 2.133-2.104v-3.592c0-1.162-.955-2.104-2.133-2.104z" }, null, -1)
  ])))
}
export default { render: render }